import styled from 'styled-components';
const { Button } = require('@ontruck/orc');

export default styled(Button)`
  background: var(--login-button-bg);
  color: var(--login-button-color);
  margin-top: 24px;
  font-size: 14px;
  font-weight: bold;
  :hover {
    background: var(--login-button-bg-hover);
  }
`;
